import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Layout } from '../components/Layout';
import { DataTable } from '../components/DataTable';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { format } from 'date-fns';

const API_URL = process.env.REACT_APP_API_URL || 'https://tecteach-server.vercel.app/api/v1';

const GenAIUsers: React.FC = () => {
  const { admin } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/users/get-genai-users?whiteLabelClientId=${admin?.whiteLabelClientId}`
        );
        setUsers(response.data);
      } catch (error) {
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    };

    if (admin?.whiteLabelClientId) {
      fetchUsers();
    }
  }, [admin]);

  const columns = [
    { id: 'name', label: 'Name' },
    { id: 'email', label: 'Email' },
    {
      id: 'createdAt',
      label: 'Joined Date',
      format: (value: string) => format(new Date(value), 'MMM dd, yyyy'),
    },
  ];

  return (
    <Layout>
      <Box>
        <Typography variant="h4" fontWeight={700} color="#142060" gutterBottom>
          GenAI Users
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Users enrolled in GenAI course
        </Typography>

        <DataTable columns={columns} data={users} loading={loading} />
      </Box>
    </Layout>
  );
};

export default GenAIUsers;
